import React, { useEffect, useRef, useState } from 'react';
import { IsB2bAgent } from '../../../../../utils/isB2bAgent';
import FlagIcon from '../../../Icons/FlagIcon';
import { ListItemIcon, ListItemText } from '@coolblue-development/becky';
import CheckmarkIcon from '../../../Icons/CheckMarkIcon';
import 'amazon-connect-streams';
import { countrySelectorUtil } from '../../../../../utils/countrySelectorUtil';
import { countryCodes, Country } from '../../../../../models/Country';
import { Button, Menu, MenuItem } from '@coolblue-development/freddy';

interface CountrySelectorProps {
  onCountrySelect: (country: Country) => void;
}

const CountrySelector: React.FC<CountrySelectorProps> = ({ onCountrySelect }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<Country | null>(null);

  const handleClick = (): void => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleMenuItemClick = (country: Country): void => {
    setSelectedCountry(country);
    onCountrySelect(country);
    handleClose();
  };

  useEffect(() => {
    const defaultCountry = countrySelectorUtil(countryCodes);
    setSelectedCountry(defaultCountry);
  }, []);

  const filteredPhoneCountryCodes = IsB2bAgent() ? countryCodes : countryCodes.filter(country => !country.isB2b);

  return (
    <>
      <Button
        ref={buttonRef}
        sx={{
          background: 'none',
          boxShadow: 'none',
          fontSize: '',
          alignSelf: 'center',
          height: '45px',
          padding: '7px',
          ':hover': { background: '#33373F', boxShadow: 'none' }
        }}
        data-testid="country-selector-button"
        size="medium"
        onClick={handleClick}
        startIcon={selectedCountry ? <FlagIcon Component={selectedCountry.icon} /> : null}
      >
        {selectedCountry?.code}
      </Button>
      <Menu
        sx={{ position: 'relative', zIndex: 20, background: '#33373F', color: '#fff' }}
        referenceElement={buttonRef.current}
        open={open}
        onClose={handleClose}
      >
        {filteredPhoneCountryCodes.map(country => (
          <MenuItem key={country.code} onClick={() => handleMenuItemClick(country)}>
            <ListItemIcon>
              <FlagIcon Component={country.icon} />
            </ListItemIcon>
            <ListItemText>{country.code}</ListItemText>
            {selectedCountry?.code === country.code && (
              <ListItemIcon sx={{ svg: { maxWidth: '10px', marginLeft: 'auto' } }}>
                <CheckmarkIcon />
              </ListItemIcon>
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default CountrySelector;
